// 기존 getCalculatedPx를 대체합니다.
function calculateTalkViewerPx(itemOriginSizePx) {
  if (!itemOriginSizePx) {
    return '0px';
  }
  // 최대 뷰어크기와 현재 뷰포트 width를 비교한 크기중 작은 크기를 사용합니다.
  const viewerWidth = 'min(100vw, 420px)';
  // 디자인가이드의 px과 비교해서 아이템에 비율을 계산합니다.
  const itemRatioPx = `calc(${viewerWidth} / 720)`;
  // 아이템 * 비율로 최종사이즈를 만들어줍니다.
  return `calc(${itemOriginSizePx} * ${itemRatioPx})`;
}

module.exports = calculateTalkViewerPx;
